import { Fragment, ReactElement } from 'react';
import Breadcrumbs, { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import StepFromAnsc from 'civil-status/pages/step-from-ansc';

interface DetailNotificationsSharedProps {
  items?: BreadcrumbItem[];
  baseUrl?: string;
}

const DetailNotificationsShared = ({
  baseUrl,
  items,
}: DetailNotificationsSharedProps): ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={items || []} />
      <StepFromAnsc isDetailAcquisitionNotifications isWithoutBreadcrumbs baseUrl={baseUrl} />
    </Fragment>
  );
};

DetailNotificationsShared.displayName = 'Detail Notifications Page component';

export default DetailNotificationsShared;
